export type TGetSessionTokenResponse = {
	baseUrl: string;
	sessionId: string;
	role: "controller";
	token: string;
	expiresAt: string;
};

export enum EToySessionState {
	IDLE = "idle",
	PENDING = "pending",
	GRANTED_STOPPED = "granted_stopped",
	GRANTED_RUNNING = "granted_running",
	SUSPENDED_OFFLINE = "suspended_offline",
	CLOSED = "closed",
}

export type TSessionStateKey = keyof typeof EToySessionState;

export type TToyStateObject = {
	initiated_by: "owner" | "controller";
	expires_at: string;
};

export type TLastStop = {
	by: "owner" | "controller";
	reason: "revoke";
	at: string;
};

export enum TLastConsentAction {
	OFFER = "offer",
	REQUEST = "request",
	ACCEPT = "accept",
	DECLINE = "decline",
	CANCEL = "cancel",
	REVOKE = "revoke",
	EXPIRE = "expire",
}

export type TLastConsent = {
	action: TLastConsentAction;
	actor: "owner" | "controller";
	at: string;
};

export type TGetToysSessionResponse = {
	session_id: string;
	external_ref: string;
	state: EToySessionState;
	device: {
		id: string;
		provider: string;
		online: boolean;
		checked_at: string;
	};
	motion: { actuators: TActuatorCommands };
	last_stop?: TLastStop | null;
	last_consent?: TLastConsent;
	version: number;
	expires_at: string;
	created_at: string;
	updated_at: string;
};

export type TActuatorValue = number | [number, number];

export type TActuatorCommand = Record<string, TActuatorValue>;

export type TActuatorCommands = Record<string, TActuatorCommand>;

export type TActuatorParameter = {
	kind: "scalar" | "span";
	min: number;
	max: number;
	required?: boolean;
	integral?: boolean;
	default?: number | [number, number];
};

export type TActuator = {
	id: string;
	type: string;
	params: Record<string, TActuatorParameter>;
};

export type TPreset = {
	id: string;
	title: string;
	actuator_type: string;
	command: TActuatorCommand;
};

export type TGetCapabilitiesResponse = {
	capabilities: {
		actuators: TActuator[];
		provider: string;
	};
	presets: TPreset[];
};
